export const BASE_URL = 'https://api.promixaccounting.com/api/v1';